import Cookies from "js-cookie";

import {
  FETCH_SIGN_UP_CONTENT,
  FETCH_SIGN_UP_CONTENT_SUCCESS,
  FETCH_SIGN_UP_CONTENT_FAILED,
  CREATE_ACCOUNT_MESSAGE,
  CREATE_ACCOUNT_MESSAGE_SUCCESS,
  CREATE_ACCOUNT_MESSAGE_FAILED,
  RESEND_EMAIL,
  RESEND_EMAIL_SUCCESS,
  RESEND_EMAIL_FAILED,
  VERIFY_EMAIL,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILED,
  BACK_TO_SIGNUP,
} from "../actions/actionTypes";

const initialState = {
  isLoading: true,
  content: {},
  error: false,
  isFormProcessing: false,
  isFirstStepCompleted: false,
  isResendingVerificationCode: false,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_SIGN_UP_CONTENT:
      return {
        ...state,
        isLoading: true,
        content: {},
      };
    case FETCH_SIGN_UP_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload,
      };
    case FETCH_SIGN_UP_CONTENT_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case CREATE_ACCOUNT_MESSAGE:
      return {
        ...state,
        isFormProcessing: true,
      };
    case CREATE_ACCOUNT_MESSAGE_SUCCESS:
      localStorage.setItem("isFirstStepCompleted", true);
      localStorage.setItem("email", payload.email);
      return {
        ...state,
        isFormProcessing: false,
        isFirstStepCompleted: true,
      };
    case CREATE_ACCOUNT_MESSAGE_FAILED:
      return {
        ...state,
        isFormProcessing: false,
        error: payload,
      };
    case BACK_TO_SIGNUP:
      return {
        ...state,
        isFirstStepCompleted: false,
      };
    case RESEND_EMAIL:
      return {
        ...state,
        isResendingVerificationCode: true,
      };
    case RESEND_EMAIL_SUCCESS:
      return {
        ...state,
        isResendingVerificationCode: false,
        isFirstStepCompleted: true,
      };
    case RESEND_EMAIL_FAILED:
      return {
        ...state,
        isResendingVerificationCode: false,
        error: payload,
      };
    case VERIFY_EMAIL:
      return {
        ...state,
        isFormProcessing: true,
        isLoading: true,
      };
    case VERIFY_EMAIL_SUCCESS:
      localStorage.removeItem("isFirstStepCompleted");
      localStorage.removeItem("email");
      localStorage.setItem("authToken", payload.authToken);
      // Cookies.set("authToken", payload.authToken);
      Cookies.set("authToken", payload.authToken, {
        domain: ".visajobsuk.com",
        path: "/",
        secure: true,
        sameSite: "None",
      });
      return {
        ...state,
        isFormProcessing: true,
        isLoading: false,
      };
    case VERIFY_EMAIL_FAILED:
      return {
        ...state,
        isFormProcessing: false,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
}
